import { Dialog } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import React, { useState } from 'react';

import { ReactComponent as IconClose } from '../../assets/svgs/icon-close.svg';

interface Props {
  isOpen: boolean;
  closeDialog: () => void;
  onKeepSession: () => void;
  onCancel: () => void;
  memberName: string;
  sessionDate: string;
}

export enum CancelSessionBookedModalTestID {
  CancelSessionBookedModalCloseButton = 'CancelSessionBookedModalCloseButton',
  CancelSessionBookedModalOnCancelButton = 'CancelSessionBookedModalOnCancelButton',
  CancelSessionBookedModalOnKeepSessionButton = 'CancelSessionBookedModalOnKeepSessionButton',
}

export const CancelSessionBookedModal: React.FC<Props> = ({
  closeDialog,
  isOpen,
  onKeepSession,
  onCancel,
  memberName,
  sessionDate,
}) => {
  const [isCancelLoading, setCancelLoading] = useState(false);

  const handleCancel = () => {
    setCancelLoading(true);
    onCancel();
  };

  return (
    <Dialog
      open={isOpen}
      onClose={closeDialog}
      aria-labelledby="form-dialog-title"
      fullWidth
      className="relative"
    >
      {isCancelLoading ? (
        <div className="inset-0 absolute w-full h-full bg-white bg-opacity-40 flex justify-center items-center z-10">
          <CircularProgress
            size={38}
            style={{
              color: '#2D80E2',
            }}
          />
        </div>
      ) : null}

      <div className="p-4 h-full relative">
        <div
          onClick={closeDialog}
          data-testid={CancelSessionBookedModalTestID.CancelSessionBookedModalCloseButton}
          className="bg-gray-300 hover:bg-gray-200 cursor-pointer rounded-full h-10 w-10 absolute top-4 right-4 flex justify-center items-center"
        >
          <IconClose className="w-3 h-3 text-gray-1000 fill-current stroke-current" />
        </div>
        <div />
        <div className="p-8 flex flex-col mb-12">
          <h1 className="font-bold text-black text-2xl mb-4">Cancel Booked Session?</h1>
          <p className="text-gray-700 text-sm">
            You're cancelling a session with {memberName}, from {sessionDate}
          </p>
        </div>

        <div className="flex flex-row justify-end">
          <button
            data-testid={CancelSessionBookedModalTestID.CancelSessionBookedModalOnKeepSessionButton}
            className="px-2 text-base mr-4 outline-none h-10 flex font-extrabold justify-center items-center text-blue-200 p-2 px-4 rounded border border-blue-200"
            onClick={onKeepSession}
          >
            Keep Session
          </button>
          <button
            data-testid={CancelSessionBookedModalTestID.CancelSessionBookedModalOnCancelButton}
            onClick={handleCancel}
            className="px-12 outline-none h-10 flex font-extrabold justify-center items-center text-white p-2 px-4 rounded hover:shadow-md bg-red-600"
          >
            Yes, Cancel
          </button>
        </div>
      </div>
    </Dialog>
  );
};
